module.exports = __webpack_public_path__ + "img/svg/mobile-logo.fbfc5f66db6b7017b6b5a78ab2b9b1c1.svg";